export const mapStateToProps = (state) => ({
  savingEdits: state.settlements.savingEdits,
});
